module.exports = __webpack_public_path__ + "static/img/ppt.49c827c0.svg";